import { Empty } from "antd";

const renderSettingsAudio = () => {
    return <Empty description={"Nothing to show."} />;
};
export default renderSettingsAudio;
